import { Pipe, PipeTransform } from '@angular/core';

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const FILE_SIZE_UNITS_LONG = [
  'Bytes',
  'Kilobytes',
  'Megabytes',
  'Gigabytes',
  'Pettabytes',
  'Exabytes',
  'Zettabytes',
  'Yottabytes',
];

@Pipe({
  name: 'formatFileSize',
})
export class FormatFileSizePipe implements PipeTransform {
  transform(sizeInBytes: number, longForm = false): string {
    if (sizeInBytes === 0) {
      return '0 Bytes';
    }

    if (!sizeInBytes || sizeInBytes < 0 || isNaN(parseInt(sizeInBytes.toString()))) {
      return '';
    }

    const units = longForm ? FILE_SIZE_UNITS_LONG : FILE_SIZE_UNITS;
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    return parseFloat((sizeInBytes / Math.pow(1024, i)).toFixed(2)) + ' ' + units[i];
  }
}
